import { Component } from 'react'
import Card from './Card'
import Button from './Button'
import '../../pages/ErrorPage.css'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, message: '' }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || 'เกิดข้อผิดพลาดในการแสดงผล' }
  }

  componentDidCatch(error, info) {
    if (this.props.onError) {
      this.props.onError(error, info)
    }
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children
    }

    return (
      <section className="mobile-page">
        <Card className="mobile-panel error-card">
          <div className="error-head">
            <p className="error-badge">Mystic Alert</p>
            <h1 className="error-title">เกิดข้อผิดพลาด</h1>
            <p className="error-subtitle">ระบบกำลังปรับพลังให้กลับมาสมดุล ลองอีกครั้งได้เลย</p>
          </div>
          <div className="error-box">
            <p className="error-message">{this.state.message}</p>
          </div>
          <div className="error-actions">
            <Button className="btn-uniform" onClick={() => window.location.reload()}>
              โหลดใหม่อีกครั้ง
            </Button>
            <Button className="btn-uniform btn-ghost" onClick={() => (window.location.href = '/game/mutelu')}>
              กลับหน้าแรก
            </Button>
          </div>
        </Card>
      </section>
    )
  }
}
